import { ReactComponent as CloseIcon } from "static/icons/close-or.svg";
import { ReactComponent as CopyIcon } from "static/icons/copy.svg";
import RenderNodeList from "../FormulaComponents/RenderNodeList/RenderNodeList";
import { useSelector } from "react-redux";

const FormulaInputWithSuggestionMode = ({
  searchTreeService,
  clearTreeHandler,
  autoActiveInputs,
  setIsValidExpression,
}) => {
  const currentTree = useSelector((state) => state.condition.currentTree);
  const currentNodeList = useSelector(
    (state) => state.condition.currentNodeList
  );
  const dropdownData = useSelector((state) => state.condition.dropdownData);

  const setNodeCallback = (options) => {
    searchTreeService.setNode(options);
    setIsValidExpression(true);
  };

  const setUpdateNodeCallback = (options) => {
    searchTreeService.updatedCurrentNode(options);
    setIsValidExpression(true);
  };

  const deleteNodeCallback = (currentNodeId) => {
    searchTreeService.deleteNode(currentNodeId);
  };

  const copyHandler = () => {
    const string = searchTreeService.createStringExpression(currentTree);
    navigator.clipboard.writeText(string);
  };

  return (
    <>
      <div className="conditional-modal__input">
        <span className="conditional-modal__input-label">Function</span>
        <div className="preview_input__inner">
          <div className="preview_input__top-content">
            <div className="icons-btns" onClick={copyHandler}>
              <CopyIcon />
            </div>
            <div className="icons-btns" onClick={clearTreeHandler}>
              <CloseIcon />
            </div>
          </div>
          <div className="preview_input">
            <RenderNodeList
              deleteNodeCallback={deleteNodeCallback}
              setNodeCallback={setNodeCallback}
              autoActiveInputs={autoActiveInputs}
              setUpdateNodeCallback={setUpdateNodeCallback}
              nodeList={currentNodeList}
              dropdownData={dropdownData}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default FormulaInputWithSuggestionMode;
